import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { GlobalMessageType } from '@spartacus/core'
import { FileSaverService } from 'ngx-filesaver'
import { finalize, Subscription } from 'rxjs'
import { RebateClaimService } from '../../../../services/rebate-claims/rebate-claim.service'
import { Month } from '../../../../services/shared/calendar/calendar.model'
import { CalendarService } from '../../../../services/shared/calendar/calendar.service'
import { CustomGlobalMessageService } from '../../../../services/shared/custom-global-message/custom-global-message.service'

@Component({
    selector: 'app-create-rebate-claim',
    templateUrl: './create-rebate-claim.component.html',
    styleUrls: ['./create-rebate-claim.component.scss'],
    standalone: false
})
export class CreateRebateClaimComponent implements OnInit, OnDestroy {
  public showInitialLoader = false
  public downloadSpinner = false
  public uploadSpinner = false
  public months: Month[] = []

  //form
  public formUpload: FormGroup
  private subscription = new Subscription()

  constructor(
    private rebateClaimService: RebateClaimService,
    private changeDetectorRef: ChangeDetectorRef,
    private fileSaverService: FileSaverService,
    public globalMessageService: CustomGlobalMessageService,
    private calendarService: CalendarService,
    private fb: FormBuilder
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  ngOnInit(): void {
    this.formUpload = this.fb.group({
      selectedMonth: new FormControl(null, Validators.required),
      fileInput: new FormControl({ value: null, disabled: true })
    })

    this.getCalendarMonths()
  }

  updateUploadForm(): void {
    const selectedMonth = this.formUpload.get('selectedMonth').value
    selectedMonth ? this.formUpload.get('fileInput').enable() : this.formUpload.get('fileInput').disable()
  }

  public onDownloadFormClick(): void {
    this.downloadSpinner = true
    const fileType = '.csv'
    const fileName = 'Rebate Claim Form' + fileType

    const rebateClaimFormSub = this.rebateClaimService.getRebateClaimForm().subscribe({
      next: (res) => {
        this.downloadSpinner = false
        this.changeDetectorRef.detectChanges()
        this.fileSaverService.save(res.body, fileName)
      },
      error: (err) => {
        this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
        this.uploadSpinner = false
      }
    })

    this.subscription.add(rebateClaimFormSub)
  }

  public onUploadClaimForm(fileList: FileList): void {
    if (!fileList || !fileList.length) {
      this.formUpload.controls.fileInput.setValue(null)
      return
    }

    const file = fileList[0]
    if (file.name.includes('.csv')) {
      this.uploadSpinner = true
      const rebateClaimFormSub = this.rebateClaimService
        .uploadRebateClaimForm(fileList, this.formUpload.value.selectedMonth.toUpperCase())
        .pipe(
          finalize(() => {
            this.uploadSpinner = false
            this.formUpload.controls.fileInput.setValue(null)
            this.changeDetectorRef.detectChanges()
          })
        )
        .subscribe({
          complete: () => {
            this.globalMessageService.add(
              { key: 'rebateClaims.newClaim.uploadSuccess' },
              GlobalMessageType.MSG_TYPE_CONFIRMATION
            )
          },
          error: (error) => {
            const msg = error.message?.replace(/,/g, '\n')
            this.globalMessageService.add(msg, GlobalMessageType.MSG_TYPE_ERROR)
          }
        })

      this.subscription.add(rebateClaimFormSub)
    } else {
      this.globalMessageService.add({ key: 'rebateClaims.newClaim.uploadFailed' }, GlobalMessageType.MSG_TYPE_ERROR)
    }
  }

  private getCalendarMonths(): void {
    const monthsSub = this.calendarService.getCalendarMonths().subscribe(
      (res) =>
        (this.months = res
          .map((item) => ({
            order: item.order,
            name: item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()
          }))
          .sort((a, b) => a.order - b.order))
    )
    this.subscription.add(monthsSub)
  }
}
